import ChatUserMessage from './ChatUserMessage';
import SystemProtectionMessage from './SystemProtectionMessage';
import ChatSystemMessage from './ChatSystemMessage';
import useElysiaStore from '@/app/elysia-store';

export type Message = {
  type: string;
  body?: string | null | undefined;
  responseBlocks?: ResponseBlock[];
  prompts?: { title: string; type: string }[];
  relatedList?: { title: string; url: string }[];
  showInteractions?: boolean;
  runId?: string; //used to log like/dislike to langsmith
  references?: MetadataSource[];
  toolResult?: SourceInteraction[];
  toolCall?: string;
  modelUsed?: string;
  languageUsed?: string;
  imageId?: string;
  chartConfig?: ChartConfig;
  pptConfig?: any;
  sqlSections?: SQLSection[];
  isElysiaError?: boolean;
  attachedFiles?: string[];
  citations?: CitationGroup[];
};

const ChatMessage = (props) => {
  const isRestrictedChatSessionStatus = useElysiaStore(
    (state) => state.isRestrictedChatSessionStatus
  );
  return (
    <>
      {props?.message?.type === 'System-Default' && (
        <>
          <SystemProtectionMessage />
        </>
      )}
      {!isRestrictedChatSessionStatus && (
        <>
          {props?.message?.type === 'System' && (
            <ChatSystemMessage
              message={props.message}
              historySystemMessage={props.historySystemMessage}
            />
          )}
          {props?.message?.type === 'User' && (
            <ChatUserMessage
              messageBody={props?.message?.body}
              attachedFiles={props?.message?.attachedFiles}
            />
          )}
          <div style={{ clear: 'both' }}></div>
        </>
      )}
    </>
  );
};

export default ChatMessage;
